<template>
    <v-container :key="fetchKey" fluid class="pa-0" style="height: inherit; background-color: white;">
        <DraggableDividedLayout v-model="EmailWidth" :hideCol2="!ShowReplaceKeys" :minValue="50" :maxValue="75">
            <template v-slot:col1>
                <v-toolbar dense flat fixed class="minitoolbar" ref="container">
                    <OtherTemplatesListButton v-if="showOtherTemplatesButton && !ShowOtherTemplates" />
                   <!--
                    <v-tabs v-model="activeTab" class="px-2" style="position: relative;" :hide-slider="true">
                        <v-tab class="px-3 rounded-tab" active-class="flowout" style="min-width: unset;">
                            <v-icon size="20" class="mr-2">mdi-information</v-icon>
                            Info
                        </v-tab>
                        <v-tab class="px-3 rounded-tab" active-class="flowout" style="min-width: unset;">
                            <v-icon size="18" class="mr-2">mdi-pencil</v-icon>
                            Edit
                        </v-tab>
                        <v-tab class="px-3 rounded-tab" active-class="flowout" style="min-width: unset;">
                            <v-icon size="20" class="mr-2">mdi-test-tube</v-icon>
                            Test
                        </v-tab>
                    </v-tabs>
                    -->
                    <v-spacer />
                    <ReplaceKeysButton v-if="!ShowReplaceKeys" :replaceKeyWords="replaceKeyWords" />
                </v-toolbar>

                <div class="px-3" :style="'overflow-y: auto; max-height: ' + contentHeight + ';'">
                    <centered-loading v-if="isLoading" :displayBool="true" :completedBool="false"
                        :displayText="$t('servicesystem.common_objects.commonterms.loading_placeholder', { pkey: $t('servicesystem.common_objects.email_settings.email_template').toLowerCase() })"
                        class="ignoreodd" style="height: 80vh;">
                    </centered-loading>

                    <v-form v-else ref="emailForm" v-model="localFormValid">
                        <EmailEditContent :configKey="configKey" :item="editItem" :editMode="true"
                            :handleFocus="() => { }" :replaceKeyWords="replaceKeyWords">
                        </EmailEditContent>
                    </v-form>
                </div>
            </template>

            <template v-slot:col2>
                <v-toolbar dense flat fixed class="minitoolbar" ref="container">
                    <v-spacer />
                    <ReplaceKeysButton :replaceKeyWords="replaceKeyWords" />
                </v-toolbar>

                <div :style="'overflow-y: auto; max-height: ' + contentHeight + ';'">
                    <EmailKeywordsNote :replaceKeyWords="replaceKeyWords">
                    </EmailKeywordsNote>
                </div>
            </template>
        </DraggableDividedLayout>
    </v-container>
</template>


<script>
import DraggableDividedLayout from '@/views/planning/DraggableDividedLayout.vue';
import EmailEditContent from '@/views/admin/settings/email/EmailEditContent.vue';
import EmailKeywordsNote from '@/views/admin/settings/email/EmailKeywordsNote.vue';
import CenteredLoading from '@/components/Sections/CenteredLoading.vue';
import EmailTemplates from '@/helpers/Constants/EmailTemplates.js';
import OtherTemplatesListButton from './OtherTemplatesListButton.vue';
import ReplaceKeysButton from './ReplaceKeysButton.vue';

export default {
    name: 'ViewEmailSetting',
    props: {
        configKey: {
            type: String,
            required: true,
        },
        showOtherTemplatesButton: Boolean,
    },
    components: {
        DraggableDividedLayout,
        CenteredLoading,
        EmailEditContent,
        EmailKeywordsNote,
        OtherTemplatesListButton,
        ReplaceKeysButton,
    },

    data() {
        return {
            isLoading: true,
            fetchKey: 1,
            localFormValid: true,
            activeTab: null,
        }
    },

    mounted() {
        this.getTemplate();
    },

    methods: {
        async getTemplate() {
            this.isLoading = true;
            try {
                await this.$store.dispatch("EmailTemplatesStore/fetchTemplateByKey", this.configKey);
            } finally {
                this.fetchKey++;
                this.isLoading = false;
            }
        },

        validateAndSaveIfRequested() {
            // called when save is requested via store
            if (this.$refs.emailForm && this.$refs.emailForm.validate) {
                const valid = this.$refs.emailForm.validate();
                this.$store.dispatch("EmailTemplatesStore/setFormValid", valid);
                if (valid && this.isDirty) {
                    this.$store.dispatch("EmailTemplatesStore/saveCurrent");
                }
            } else {
                // Fallback: assume valid
                this.$store.dispatch("EmailTemplatesStore/setFormValid", true);
                if (this.isDirty) {
                    this.$store.dispatch("EmailTemplatesStore/saveCurrent");
                }
            }
        }
    },

    computed: {
        longDescription() {
            const meta = EmailTemplates[this.configKey];
            return meta?.descriptionLong || '';
        },

        editItem() {
            return this.$store.getters["EmailTemplatesStore/editItem"];
        },
        isDirty() {
            return this.$store.getters["EmailTemplatesStore/isDirty"];
        },

        saveRequestCounter() {
            return this.$store.getters["EmailTemplatesStore/saveRequestCounter"];
        },

        replaceKeyWords() {
            return this.editItem?.ReplaceKeyWords ?? [];
        },

        hasReplaceKeywords() {
            return this.replaceKeyWords && this.replaceKeyWords[0];
        },

        replaceKeysVisibleAndPresent() {
            return this.ShowReplaceKeys && !!this.hasReplaceKeywords
        },

        ShowOtherTemplates() {
            return this.$store.getters["prefrences/Prefrence"]("ShowOtherTemplates");
        },

        ShowReplaceKeys: {
            get() {
                return this.$store.getters["prefrences/Prefrence"]("ShowReplaceKeys");
            },
            set(update) {
                this.$store.dispatch("prefrences/set_prefrence", { key: "ShowReplaceKeys", value: update });
            },
        },

        ReplaceKeysWidth: {
            get() {
                return this.$store.getters["prefrences/Prefrence"]("ReplaceKeysWidth");
            },
            set(update) {
                this.$store.dispatch("prefrences/set_prefrence", { key: "ReplaceKeysWidth", value: update });
            },
        },

        EmailWidth: {
            get() {
                return 100 - this.ReplaceKeysWidth;
            },
            set(update) {
                this.ReplaceKeysWidth = 100 - update;
            },
        },

        contentHeight() {
            var contentHeight = this.$store.getters['navstore/ContentContainerHeight'];
            return 'calc(' + contentHeight + 'px - 48px)';
        },
    },

    watch: {
        configKey: function () {
            this.getTemplate();
        },
        localFormValid: function (val) {
            this.$store.dispatch("EmailTemplatesStore/setFormValid", val);
        },
        saveRequestCounter: function () {
            this.validateAndSaveIfRequested();
        },
    },
};
</script>


<style lang='scss' scoped></style>